import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

export interface ValidationErrorDialogData {
	errors: string[];
}

@Component({
	selector: 'app-rapid-application-modal-validation-error-dialog',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
	template: `
		<h2 mat-dialog-title>
			<mat-icon color="warn" class="me-2" style="vertical-align: middle">warning</mat-icon>
			Validation Errors
		</h2>
		<mat-dialog-content>
			<p class="mb-3">Please fix the following errors before submitting:</p>
			<ul class="error-list">
				<li *ngFor="let error of data.errors" class="error-item">
					{{ error }}
				</li>
			</ul>
		</mat-dialog-content>
		<mat-dialog-actions align="end">
			<button mat-raised-button color="primary" [mat-dialog-close]="true">
				OK
			</button>
		</mat-dialog-actions>
	`,
	styles: [
		`
			.error-list {
				list-style-type: disc;
				padding-left: 20px;
				margin: 0;
			}

			.error-item {
				color: #d32f2f;
				margin-bottom: 8px;
			}

			mat-dialog-content {
				min-width: 400px;
				max-width: 600px;
			}
		`,
	],
})
export class ValidationErrorDialog {
	constructor(
		public dialogRef: MatDialogRef<ValidationErrorDialog>,
		@Inject(MAT_DIALOG_DATA) public data: ValidationErrorDialogData
	) {}
}